import styled from 'styled-components';
import device from '../../mediaQueries';

const FooterWrapper = styled.div`
  width: 100%;
  margin: auto;
  padding-bottom: 5px;
  background-color: #000;
  ${device.mobile`
  display: flex;
    flex-direction: column;
  `}
`;

export default FooterWrapper;
